// Mock data for Peterborough Repair Cafe UK

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    rating: 5,
    date: "November 2024",
    comment: "The volunteers were absolutely brilliant! They fixed my coffee maker that I thought was beyond repair. So grateful for this wonderful community initiative.",
    avatar: "SM"
  },
  {
    id: 2,
    name: "James Peterson",
    rating: 5,
    date: "October 2024",
    comment: "Brought in my daughter's favorite toy that stopped working. The team not only fixed it but showed me how to maintain it. Fantastic service!",
    avatar: "JP"
  },
  {
    id: 3,
    name: "Emily Roberts",
    rating: 5,
    date: "September 2024",
    comment: "I've been to three repair cafes now. Each time I'm amazed by the skills and patience of the volunteers. They're helping our community reduce waste in such a practical way.",
    avatar: "ER"
  },
  {
    id: 4,
    name: "David Chen",
    rating: 5,
    date: "August 2024",
    comment: "My bicycle has been sitting in the shed for months. The repair cafe team got it back on the road in under an hour. Absolutely wonderful!",
    avatar: "DC"
  },
  {
    id: 5,
    name: "Linda Thompson",
    rating: 5,
    date: "July 2024",
    comment: "Not only did they repair my lamp, but I learned so much about basic electrical repairs. The volunteers are friendly, knowledgeable, and truly care about helping.",
    avatar: "LT"
  },
  {
    id: 6,
    name: "Michael Brown",
    rating: 5,
    date: "June 2024",
    comment: "Fantastic initiative! They repaired my vacuum cleaner and gave me tips on maintaining household appliances. This is what community is all about.",
    avatar: "MB"
  }
];

export const services = [
  {
    id: 1,
    slug: "electrical",
    title: "Small Electrical Appliances",
    description: "Toasters, kettles, coffee makers, lamps, fans, and other small electrical items.",
    icon: "Zap"
  },
  {
    id: 2,
    slug: "household",
    title: "Household Items",
    description: "Functional repairs for household items, gadgets, and everyday equipment.",
    icon: "Home"
  },
  {
    id: 3,
    slug: "toys-gadgets",
    title: "Toys & Gadgets",
    description: "Children's toys, remote-controlled devices, and electronic gadgets.",
    icon: "Gamepad2"
  },
  {
    id: 4,
    slug: "clothing-textiles",
    title: "Clothing & Textiles",
    description: "Sewing repairs, functional alterations, patching, and soft toy repairs.",
    icon: "Scissors"
  },
  {
    id: 5,
    slug: "bicycles-mechanical",
    title: "Bicycles & Mechanical Items",
    description: "Basic bike repairs, chain adjustments, brake fixes, mechanical maintenance, and small garden equipment repairs.",
    icon: "Bike"
  },
  {
    id: 6,
    slug: "tool-sharpening",
    title: "Tool Sharpening",
    description: "From chisels to garden shears, bring your blunt tools back to life.",
    icon: "Wrench"
  }
];

export const volunteers = [
  {
    id: 1,
    name: "Tom Harrison",
    specialty: "Electronics & Electrical",
    experience: "15 years",
    avatar: "TH"
  },
  {
    id: 2,
    name: "Rachel Green",
    specialty: "Textiles & Sewing",
    experience: "10 years",
    avatar: "RG"
  },
  {
    id: 3,
    name: "Peter Walsh",
    specialty: "Bicycles & Mechanical",
    experience: "20 years",
    avatar: "PW"
  },
  {
    id: 4,
    name: "Sophie Turner",
    specialty: "General Repairs",
    experience: "8 years",
    avatar: "ST"
  }
];

export const impactStats = [
  {
    id: 1,
    number: "500+",
    label: "Items Repaired",
    icon: "CheckCircle2"
  },
  {
    id: 2,
    number: "300+",
    label: "Community Members Helped",
    icon: "Users"
  },
  {
    id: 3,
    number: "2.5 Tonnes",
    label: "Waste Prevented",
    icon: "Leaf"
  },
  {
    id: 4,
    number: "48",
    label: "Monthly Events Held",
    icon: "Calendar"
  }
];

export const repairProcess = [
  {
    id: 1,
    step: "01",
    title: "Submit Request",
    description: "Fill out our simple repair request form with details about your item and the issue."
  },
  {
    id: 2,
    step: "02",
    title: "We Review",
    description: "Our volunteer team reviews your request and confirms availability for the next event."
  },
  {
    id: 3,
    step: "03",
    title: "Visit the Event",
    description: "Bring your item to our monthly repair cafe on the first Saturday of the month."
  },
  {
    id: 4,
    step: "04",
    title: "Get It Fixed",
    description: "Our skilled volunteers will attempt to repair your item for free, right on the spot!"
  }
];
